import { Errback } from '@tanem/svg-injector';
import React from 'react';
import { forceReloadChrome96Bug } from '@gettactic/helpers/src/map/svg/forceReloadChrome96Bug';
import { parseInteractiveZonesSvg } from '@gettactic/helpers/src/map/svg/parseInteractiveZonesSvg';
import { fillDynamicLabels } from '@/lib/utils-map';
import { useBooleanState } from '@gettactic/helpers';
import { useMap } from '@webV2/map/MapProvider';

export const useOnMapLoaded = (
  onMapLoadedCallback?: (svg: SVGSVGElement | undefined) => void
) => {
  const { setResourcesIdFilter, setZonesInfo, schedulable } = useMap();
  const isLoading = useBooleanState();
  const svgRef = React.useRef<SVGSVGElement | null | undefined>(null);

  const onMapLoaded: Errback = React.useCallback(
    (err, svg) => {
      if (err) {
        console.error(err);
        return;
      }
      isLoading.true();
      // save a SVG reference to reparse
      // during window resizes
      svgRef.current = svg;
      // @todo remove hack chrome96Bug
      //setTimeout(forceReloadChrome96Bug, 500);
      setTimeout(() => {
        if (!svgRef.current) {
          return;
        }
        const zones = parseInteractiveZonesSvg(svgRef.current, {
          applyMatrixTransformToPosition: true
        });
        setResourcesIdFilter(zones?.zones.map((zone) => zone.id) || []);
        if (!zones) return;
        setZonesInfo(zones);
        isLoading.false();
      }, 100);
      fillDynamicLabels(svgRef.current as SVGElement, schedulable);
      onMapLoadedCallback?.(svg);
    },
    [svgRef]
  );

  return { svgRef, onMapLoaded, isLoading };
};
